import React, { useState } from 'react';
import { Investment, Document } from '@/types/investment';
import { Button } from '@/components/Button';
import { RequestModal } from '@/components/ui/RequestModal';

interface DocumentsProps {
  investment: Investment;
}

const Documents: React.FC<DocumentsProps> = ({ investment }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState<Document | null>(null);

  const handleRequestClick = (doc: Document) => {
    setSelectedDoc(doc);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedDoc(null);
  };

  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-semibold text-foreground">Documents</h2>
      <div className="mt-6 border-t border-border">
        <ul className="divide-y divide-border">
          {investment.documents.length > 0 ? (
            investment.documents.map((doc, index) => (
              <li key={index} className="flex items-center justify-between py-3">
                <div className="flex flex-col">
                  <span className="font-medium text-sm text-foreground">{doc.name}</span>
                  <span className="text-xs text-muted-foreground">Upon Request</span>
                </div>
                <Button variant="outline" size="sm" onClick={() => handleRequestClick(doc)}>
                  Request
                </Button>
              </li>
            ))
          ) : (
            <p className="text-muted-foreground py-4">No documents available for this investment.</p>
          )}
        </ul>
      </div>

      {selectedDoc && (
        <RequestModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          docName={selectedDoc.name}
          investmentName={investment.name}
        />
      )}
    </div>
  );
};



export default Documents;
